import { setCookie, getCookie } from './cookie';

const FBC_COOKIE_NAME = '_fbc';
const FBC_COOKIE_EXPIRATION_DAYS = 90;
const FBP_COOKIE_NAME = '_fbp';

/**
 * Reads fbclid from the query string without altering casing or truncating the value.
 * Uses a regex on location.search so the click id is taken exactly as Meta sent it.
 */
export function getFbclidFromUrl(search: string = ''): string | null {
    if (!search) {
        return null;
    }

    const match = search.match(/[?&]fbclid=([^&#]*)/);
    if (!match?.[1]) {
        return null;
    }

    const raw = match[1];

    try {
        return decodeURIComponent(raw.replace(/\+/g, ' '));
    } catch {
        return raw;
    }
}

export function buildFbcFromFbclid(
    fbclid: string,
    creationTime = Date.now(),
): string {
    return `fb.1.${creationTime}.${fbclid}`;
}

export function captureMetaClickId(): void {
    if (typeof window === 'undefined') {
        return;
    }

    const fbclidFromUrl = getFbclidFromUrl(window.location.search);

    // When fbclid is in the URL it is the source of truth (exact casing from the ad
    // click). Always refresh _fbc from it so a pixel- or SDK-written cookie cannot
    // leave a lowercased/truncated click id in place.
    if (fbclidFromUrl) {
        const fbc = buildFbcFromFbclid(fbclidFromUrl);
        setCookie(FBC_COOKIE_NAME, fbc, FBC_COOKIE_EXPIRATION_DAYS);
    }
}

export function getMetaClickId(): string | null {
    return getCookie(FBC_COOKIE_NAME);
}

export function getMetaBrowserId(): string | null {
    return getCookie(FBP_COOKIE_NAME);
}
